__turbopack_context__.v({
  "placeholder__container": "LHwZkW_placeholder__container",
  "placeholder__container--1": "LHwZkW_placeholder__container--1",
  "placeholder__container--2": "LHwZkW_placeholder__container--2",
  "placeholder__container--3": "LHwZkW_placeholder__container--3",
  "placeholder__container--4": "LHwZkW_placeholder__container--4",
  "placeholder__container--5": "LHwZkW_placeholder__container--5",
  "placeholder__text": "LHwZkW_placeholder__text",
});
